import React from 'react';

import { bundledConfig } from '~src/config/bundled-config';

interface CountryIconProps {
  countryCode: string;
  height?: React.CSSProperties['height'];
}

export const CountryLogo: React.VFC<CountryIconProps> = ({ countryCode, height = 24 }) => {
  return (
    <img
      aria-hidden="true"
      height={height}
      src={`${bundledConfig.cdnUrl}/static/country-flags/${countryCode.toLowerCase()}.svg`}
      alt={countryCode}
    />
  );
};
